import { TRADE_FIELD_NAMES, TradeFieldName } from '@models/doors';

export function findTradeFieldByPropertyName(propertyName: string | undefined): TradeFieldName | undefined {
  return TRADE_FIELD_NAMES.find((name) => name === propertyName);
}
